(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode("._errorWrapper_171rr_1{word-break:break-word}._copyIcon_171rr_5{cursor:pointer;color:var(--dixa-typography-color-secondary)}._settingsWrapper_eleyu_1{border:var(--dixa-size-border-100) solid var(--dixa-color-neutral-300);border-radius:var(--dixa-size-border-radius-100);padding:var(--dixa-size-spacer-300);margin-bottom:var(--dixa-size-spacer-300)}")),document.head.appendChild(r)}}catch(e){console.error("vite-plugin-css-injected-by-js",e)}})();
import { useQuery as Yr, useLazyQuery as Kr, useMutation as Hr, isApolloError as Jr, gql as Me } from "@apollo/client";
import { __extends as zr } from "tslib";
import cr, { useState as P, useEffect as k, createContext as lr, useContext as ur } from "react";
import { FormField as oe, FieldWrapper as Q, Badge as je, Icon as Fe, FlexBox as W, Text as ae, List as Xe, Banner as qr, Button as ke, Tooltip as Qr, Spinner as fr, FieldSwitch as Zr, InputSelectionList as Xr, SelectionList as et } from "@dixa/lib-shared-habla";
import { Link as rt } from "react-router-dom";
import { colors as G } from "@dixa/lib-shared-tokens";
import { useInterval as tt } from "react-use";
import nt from "moment";
var Ie = "Invariant Violation", er = Object.setPrototypeOf, ot = er === void 0 ? function(r, t) {
  return r.__proto__ = t, r;
} : er, at = (
  /** @class */
  (function(r) {
    zr(t, r);
    function t(a) {
      a === void 0 && (a = Ie);
      var i = r.call(this, typeof a == "number" ? Ie + ": " + a + " (see https://github.com/apollographql/invariant-packages)" : a) || this;
      return i.framesToPop = 1, i.name = Ie, ot(i, t.prototype), i;
    }
    return t;
  })(Error)
);
function Y(r, t) {
  if (!r)
    throw new at(t);
}
var dr = ["debug", "log", "warn", "error", "silent"], it = dr.indexOf("log");
function he(r) {
  return function() {
    if (dr.indexOf(r) >= it) {
      var t = console[r] || console.log;
      return t.apply(console, arguments);
    }
  };
}
(function(r) {
  r.debug = he("debug"), r.log = he("log"), r.warn = he("warn"), r.error = he("error");
})(Y || (Y = {}));
var pr = "3.14.0";
function q(r) {
  try {
    return r();
  } catch {
  }
}
const rr = q(function() {
  return globalThis;
}) || q(function() {
  return window;
}) || q(function() {
  return self;
}) || q(function() {
  return global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
q(function() {
  return q.constructor("return this")();
});
var tr = /* @__PURE__ */ new Map();
function st(r) {
  var t = tr.get(r) || 1;
  return tr.set(r, t + 1), "".concat(r, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
}
function ct(r, t) {
  var a = st("stringifyForDisplay");
  return JSON.stringify(r, function(i, u) {
    return u === void 0 ? a : u;
  }, t).split(JSON.stringify(a)).join("<undefined>");
}
function ge(r) {
  return function(t) {
    for (var a = [], i = 1; i < arguments.length; i++)
      a[i - 1] = arguments[i];
    if (typeof t == "number") {
      var u = t;
      t = gr(u), t || (t = vr(u, a), a = []);
    }
    r.apply(void 0, [t].concat(a));
  };
}
Object.assign(function(t, a) {
  for (var i = [], u = 2; u < arguments.length; u++)
    i[u - 2] = arguments[u];
  t || Y(t, gr(a, i) || vr(a, i));
}, {
  debug: ge(Y.debug),
  log: ge(Y.log),
  warn: ge(Y.warn),
  error: ge(Y.error)
});
var nr = Symbol.for("ApolloErrorMessageHandler_" + pr);
function hr(r) {
  if (typeof r == "string")
    return r;
  try {
    return ct(r, 2).slice(0, 1e3);
  } catch {
    return "<non-serializable>";
  }
}
function gr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return rr[nr] && rr[nr](r, t.map(hr));
}
function vr(r, t) {
  if (t === void 0 && (t = []), !!r)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: pr,
      message: r,
      args: t.map(hr)
    })));
}
function me(r) {
  return r.definitions.filter(function(t) {
    return t.kind === "OperationDefinition" && !!t.name;
  }).map(function(t) {
    return t.name.value;
  })[0] || null;
}
const Jt = (r, t) => function(a, i) {
  return Yr(a, {
    ...i,
    context: {
      operationName: me(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, zt = (r, t) => function(a, i) {
  return Kr(a, {
    ...i,
    context: {
      operationName: me(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
}, qt = (r, t, a) => function(i, u) {
  return a.query({
    query: i,
    variables: u,
    context: {
      operationName: me(i),
      widgetId: r,
      widgetType: t
    }
  });
}, Qt = (r, t) => function(a, i) {
  return Hr(a, {
    ...i,
    context: {
      operationName: me(a),
      ...i?.context,
      widgetId: r,
      widgetType: t
    }
  });
};
var ve = { exports: {} }, te = {};
var or;
function lt() {
  if (or) return te;
  or = 1;
  var r = cr, t = Symbol.for("react.element"), a = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, u = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, m = { key: !0, ref: !0, __self: !0, __source: !0 };
  function y(T, g, x) {
    var p, E = {}, S = null, R = null;
    x !== void 0 && (S = "" + x), g.key !== void 0 && (S = "" + g.key), g.ref !== void 0 && (R = g.ref);
    for (p in g) i.call(g, p) && !m.hasOwnProperty(p) && (E[p] = g[p]);
    if (T && T.defaultProps) for (p in g = T.defaultProps, g) E[p] === void 0 && (E[p] = g[p]);
    return { $$typeof: t, type: T, key: S, ref: R, props: E, _owner: u.current };
  }
  return te.Fragment = a, te.jsx = y, te.jsxs = y, te;
}
var ne = {};
var ar;
function ut() {
  return ar || (ar = 1, process.env.NODE_ENV !== "production" && (function() {
    var r = cr, t = Symbol.for("react.element"), a = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), m = Symbol.for("react.profiler"), y = Symbol.for("react.provider"), T = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), x = Symbol.for("react.suspense"), p = Symbol.for("react.suspense_list"), E = Symbol.for("react.memo"), S = Symbol.for("react.lazy"), R = Symbol.for("react.offscreen"), I = Symbol.iterator, A = "@@iterator";
    function N(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = I && e[I] || e[A];
      return typeof n == "function" ? n : null;
    }
    var d = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(e) {
      {
        for (var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)
          o[c - 1] = arguments[c];
        $("error", e, o);
      }
    }
    function $(e, n, o) {
      {
        var c = d.ReactDebugCurrentFrame, h = c.getStackAddendum();
        h !== "" && (n += "%s", o = o.concat([h]));
        var v = o.map(function(f) {
          return String(f);
        });
        v.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, v);
      }
    }
    var Z = !1, Ee = !1, ye = !1, be = !1, Ce = !1, ie;
    ie = Symbol.for("react.module.reference");
    function Re(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === i || e === m || Ce || e === u || e === x || e === p || be || e === R || Z || Ee || ye || typeof e == "object" && e !== null && (e.$$typeof === S || e.$$typeof === E || e.$$typeof === y || e.$$typeof === T || e.$$typeof === g || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === ie || e.getModuleId !== void 0));
    }
    function K(e, n, o) {
      var c = e.displayName;
      if (c)
        return c;
      var h = n.displayName || n.name || "";
      return h !== "" ? o + "(" + h + ")" : o;
    }
    function se(e) {
      return e.displayName || "Context";
    }
    function M(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case i:
          return "Fragment";
        case a:
          return "Portal";
        case m:
          return "Profiler";
        case u:
          return "StrictMode";
        case x:
          return "Suspense";
        case p:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case T:
            var n = e;
            return se(n) + ".Consumer";
          case y:
            var o = e;
            return se(o._context) + ".Provider";
          case g:
            return K(e, e.render, "ForwardRef");
          case E:
            var c = e.displayName || null;
            return c !== null ? c : M(e.type) || "Memo";
          case S: {
            var h = e, v = h._payload, f = h._init;
            try {
              return M(f(v));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var F = Object.assign, U = 0, H, ce, X, O, L, B, ee;
    function le() {
    }
    le.__reactDisabledLog = !0;
    function _e() {
      {
        if (U === 0) {
          H = console.log, ce = console.info, X = console.warn, O = console.error, L = console.group, B = console.groupCollapsed, ee = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: le,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        U++;
      }
    }
    function yr() {
      {
        if (U--, U === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: F({}, e, {
              value: H
            }),
            info: F({}, e, {
              value: ce
            }),
            warn: F({}, e, {
              value: X
            }),
            error: F({}, e, {
              value: O
            }),
            group: F({}, e, {
              value: L
            }),
            groupCollapsed: F({}, e, {
              value: B
            }),
            groupEnd: F({}, e, {
              value: ee
            })
          });
        }
        U < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Oe = d.ReactCurrentDispatcher, Te;
    function ue(e, n, o) {
      {
        if (Te === void 0)
          try {
            throw Error();
          } catch (h) {
            var c = h.stack.trim().match(/\n( *(at )?)/);
            Te = c && c[1] || "";
          }
        return `
` + Te + e;
      }
    }
    var xe = !1, fe;
    {
      var br = typeof WeakMap == "function" ? WeakMap : Map;
      fe = new br();
    }
    function Le(e, n) {
      if (!e || xe)
        return "";
      {
        var o = fe.get(e);
        if (o !== void 0)
          return o;
      }
      var c;
      xe = !0;
      var h = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var v;
      v = Oe.current, Oe.current = null, _e();
      try {
        if (n) {
          var f = function() {
            throw Error();
          };
          if (Object.defineProperty(f.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(f, []);
            } catch (D) {
              c = D;
            }
            Reflect.construct(e, [], f);
          } else {
            try {
              f.call();
            } catch (D) {
              c = D;
            }
            e.call(f.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (D) {
            c = D;
          }
          e();
        }
      } catch (D) {
        if (D && c && typeof D.stack == "string") {
          for (var l = D.stack.split(`
`), w = c.stack.split(`
`), C = l.length - 1, _ = w.length - 1; C >= 1 && _ >= 0 && l[C] !== w[_]; )
            _--;
          for (; C >= 1 && _ >= 0; C--, _--)
            if (l[C] !== w[_]) {
              if (C !== 1 || _ !== 1)
                do
                  if (C--, _--, _ < 0 || l[C] !== w[_]) {
                    var j = `
` + l[C].replace(" at new ", " at ");
                    return e.displayName && j.includes("<anonymous>") && (j = j.replace("<anonymous>", e.displayName)), typeof e == "function" && fe.set(e, j), j;
                  }
                while (C >= 1 && _ >= 0);
              break;
            }
        }
      } finally {
        xe = !1, Oe.current = v, yr(), Error.prepareStackTrace = h;
      }
      var z = e ? e.displayName || e.name : "", V = z ? ue(z) : "";
      return typeof e == "function" && fe.set(e, V), V;
    }
    function Cr(e, n, o) {
      return Le(e, !1);
    }
    function Rr(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function de(e, n, o) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return Le(e, Rr(e));
      if (typeof e == "string")
        return ue(e);
      switch (e) {
        case x:
          return ue("Suspense");
        case p:
          return ue("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case g:
            return Cr(e.render);
          case E:
            return de(e.type, n, o);
          case S: {
            var c = e, h = c._payload, v = c._init;
            try {
              return de(v(h), n, o);
            } catch {
            }
          }
        }
      return "";
    }
    var re = Object.prototype.hasOwnProperty, We = {}, $e = d.ReactDebugCurrentFrame;
    function pe(e) {
      if (e) {
        var n = e._owner, o = de(e.type, e._source, n ? n.type : null);
        $e.setExtraStackFrame(o);
      } else
        $e.setExtraStackFrame(null);
    }
    function _r(e, n, o, c, h) {
      {
        var v = Function.call.bind(re);
        for (var f in e)
          if (v(e, f)) {
            var l = void 0;
            try {
              if (typeof e[f] != "function") {
                var w = Error((c || "React class") + ": " + o + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw w.name = "Invariant Violation", w;
              }
              l = e[f](n, f, c, o, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (C) {
              l = C;
            }
            l && !(l instanceof Error) && (pe(h), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", c || "React class", o, f, typeof l), pe(null)), l instanceof Error && !(l.message in We) && (We[l.message] = !0, pe(h), b("Failed %s type: %s", o, l.message), pe(null));
          }
      }
    }
    var Or = Array.isArray;
    function Se(e) {
      return Or(e);
    }
    function Tr(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, o = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return o;
      }
    }
    function xr(e) {
      try {
        return Ue(e), !1;
      } catch {
        return !0;
      }
    }
    function Ue(e) {
      return "" + e;
    }
    function Be(e) {
      if (xr(e))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Tr(e)), Ue(e);
    }
    var Ge = d.ReactCurrentOwner, Sr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ve, Ye;
    function Ar(e) {
      if (re.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function wr(e) {
      if (re.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function Nr(e, n) {
      typeof e.ref == "string" && Ge.current;
    }
    function Dr(e, n) {
      {
        var o = function() {
          Ve || (Ve = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: o,
          configurable: !0
        });
      }
    }
    function Ir(e, n) {
      {
        var o = function() {
          Ye || (Ye = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        o.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: o,
          configurable: !0
        });
      }
    }
    var Pr = function(e, n, o, c, h, v, f) {
      var l = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: o,
        props: f,
        // Record the component responsible for creating this element.
        _owner: v
      };
      return l._store = {}, Object.defineProperty(l._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(l, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: c
      }), Object.defineProperty(l, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: h
      }), Object.freeze && (Object.freeze(l.props), Object.freeze(l)), l;
    };
    function jr(e, n, o, c, h) {
      {
        var v, f = {}, l = null, w = null;
        o !== void 0 && (Be(o), l = "" + o), wr(n) && (Be(n.key), l = "" + n.key), Ar(n) && (w = n.ref, Nr(n, h));
        for (v in n)
          re.call(n, v) && !Sr.hasOwnProperty(v) && (f[v] = n[v]);
        if (e && e.defaultProps) {
          var C = e.defaultProps;
          for (v in C)
            f[v] === void 0 && (f[v] = C[v]);
        }
        if (l || w) {
          var _ = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          l && Dr(f, _), w && Ir(f, _);
        }
        return Pr(e, l, w, h, c, Ge.current, f);
      }
    }
    var Ae = d.ReactCurrentOwner, Ke = d.ReactDebugCurrentFrame;
    function J(e) {
      if (e) {
        var n = e._owner, o = de(e.type, e._source, n ? n.type : null);
        Ke.setExtraStackFrame(o);
      } else
        Ke.setExtraStackFrame(null);
    }
    var we;
    we = !1;
    function Ne(e) {
      return typeof e == "object" && e !== null && e.$$typeof === t;
    }
    function He() {
      {
        if (Ae.current) {
          var e = M(Ae.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function kr(e) {
      return "";
    }
    var Je = {};
    function Mr(e) {
      {
        var n = He();
        if (!n) {
          var o = typeof e == "string" ? e : e.displayName || e.name;
          o && (n = `

Check the top-level render call using <` + o + ">.");
        }
        return n;
      }
    }
    function ze(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var o = Mr(n);
        if (Je[o])
          return;
        Je[o] = !0;
        var c = "";
        e && e._owner && e._owner !== Ae.current && (c = " It was passed a child from " + M(e._owner.type) + "."), J(e), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', o, c), J(null);
      }
    }
    function qe(e, n) {
      {
        if (typeof e != "object")
          return;
        if (Se(e))
          for (var o = 0; o < e.length; o++) {
            var c = e[o];
            Ne(c) && ze(c, n);
          }
        else if (Ne(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var h = N(e);
          if (typeof h == "function" && h !== e.entries)
            for (var v = h.call(e), f; !(f = v.next()).done; )
              Ne(f.value) && ze(f.value, n);
        }
      }
    }
    function Fr(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var o;
        if (typeof n == "function")
          o = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === g || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === E))
          o = n.propTypes;
        else
          return;
        if (o) {
          var c = M(n);
          _r(o, e.props, "prop", c, e);
        } else if (n.PropTypes !== void 0 && !we) {
          we = !0;
          var h = M(n);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", h || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Lr(e) {
      {
        for (var n = Object.keys(e.props), o = 0; o < n.length; o++) {
          var c = n[o];
          if (c !== "children" && c !== "key") {
            J(e), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", c), J(null);
            break;
          }
        }
        e.ref !== null && (J(e), b("Invalid attribute `ref` supplied to `React.Fragment`."), J(null));
      }
    }
    var Qe = {};
    function Ze(e, n, o, c, h, v) {
      {
        var f = Re(e);
        if (!f) {
          var l = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (l += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var w = kr();
          w ? l += w : l += He();
          var C;
          e === null ? C = "null" : Se(e) ? C = "array" : e !== void 0 && e.$$typeof === t ? (C = "<" + (M(e.type) || "Unknown") + " />", l = " Did you accidentally export a JSX literal instead of a component?") : C = typeof e, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", C, l);
        }
        var _ = jr(e, n, o, h, v);
        if (_ == null)
          return _;
        if (f) {
          var j = n.children;
          if (j !== void 0)
            if (c)
              if (Se(j)) {
                for (var z = 0; z < j.length; z++)
                  qe(j[z], e);
                Object.freeze && Object.freeze(j);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              qe(j, e);
        }
        if (re.call(n, "key")) {
          var V = M(e), D = Object.keys(n).filter(function(Vr) {
            return Vr !== "key";
          }), De = D.length > 0 ? "{key: someKey, " + D.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Qe[V + De]) {
            var Gr = D.length > 0 ? "{" + D.join(": ..., ") + ": ...}" : "{}";
            b(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, De, V, Gr, V), Qe[V + De] = !0;
          }
        }
        return e === i ? Lr(_) : Fr(_), _;
      }
    }
    function Wr(e, n, o) {
      return Ze(e, n, o, !0);
    }
    function $r(e, n, o) {
      return Ze(e, n, o, !1);
    }
    var Ur = $r, Br = Wr;
    ne.Fragment = i, ne.jsx = Ur, ne.jsxs = Br;
  })()), ne;
}
var ir;
function ft() {
  return ir || (ir = 1, process.env.NODE_ENV === "production" ? ve.exports = lt() : ve.exports = ut()), ve.exports;
}
var s = ft();
const Zt = ({
  getValueByKey: r
}) => {
  const t = r("dixaApiTokenId")?.value, a = r("dixaApiTokenName")?.value;
  return /* @__PURE__ */ s.jsx(oe, { children: /* @__PURE__ */ s.jsx(Q, { label: "Dixa API-Token", children: !a || !t ? /* @__PURE__ */ s.jsx(s.Fragment, { children: "Something seems odd with the Api-Token. No name and/or id available." }) : /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    "A Dixa Token with the name",
    " ",
    /* @__PURE__ */ s.jsx(je, { variant: "secondary", size: "small", children: a }),
    " ",
    "was created.",
    " ",
    /* @__PURE__ */ s.jsx(rt, { to: `/settings/integrations/api-tokens/${t}`, children: "You can visit it on the Api-Token page" }),
    "."
  ] }) }) });
}, dt = ({
  error: r
}) => r.extensions?.integration?.code === "DIXA_HEADER_CHECK_ERROR", Xt = ({
  errors: r
}) => r.some((t) => dt({ error: t })), pt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_AUTHORIZATION_ERROR", en = ({
  errors: r
}) => r.some((t) => pt({ error: t })), ht = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_PERMISSION_ERROR", rn = ({
  errors: r
}) => r.some((t) => ht({ error: t })), gt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_SERVICE_UNAVAILABLE_ERROR", tn = ({
  errors: r
}) => r.some((t) => gt({ error: t })), vt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_NOT_FOUND_ERROR", nn = ({
  errors: r
}) => r.some((t) => vt({ error: t })), mt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_CONFLICT_ERROR", on = ({
  errors: r
}) => r.some((t) => mt({ error: t })), Et = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_BAD_REQUEST_ERROR", an = ({
  errors: r
}) => r.some((t) => Et({ error: t })), yt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_FORBIDDEN_ERROR", sn = ({
  errors: r
}) => r.some((t) => yt({ error: t })), bt = ({
  error: r
}) => r.extensions?.integration?.code === "DOWNSTREAM_API_TOO_MANY_REQUESTS_ERROR", cn = ({
  errors: r
}) => r.some((t) => bt({ error: t })), Ct = ({
  error: r
}) => r.extensions?.integration?.code === "WIDGET_MISCONFIGURED_ERROR", Rt = ({
  errors: r
}) => r.some((t) => Ct({ error: t })), _t = (r) => {
  const { delay: t = 2e3 } = r || {}, [a, i] = P(!1);
  return k(() => {
    const m = a ? window.setTimeout(() => i(!1), t) : void 0;
    return () => window.clearTimeout(m);
  }, [t, a]), { isCopied: a, copy: (m) => {
    navigator.clipboard.writeText(m), i(!0);
  } };
}, Ot = "_errorWrapper_171rr_1", Tt = "_copyIcon_171rr_5", Pe = {
  errorWrapper: Ot,
  copyIcon: Tt
}, xt = ({
  error: r,
  retry: t,
  isMisconfigured: a = !1
}) => {
  const u = r && Jr(r) && r?.graphQLErrors?.length > 0, { isCopied: m, copy: y } = _t(), T = /* @__PURE__ */ s.jsx(
    Fe,
    {
      color: G.red[500],
      size: 16,
      name: "exclamation-triangle-filled"
    }
  );
  if (a || u && Rt({
    errors: r.graphQLErrors
  }))
    return /* @__PURE__ */ s.jsxs(W, { margin: "0 0 100", padding: "200", className: Pe.errorWrapper, children: [
      /* @__PURE__ */ s.jsx(W, { margin: "0 300 0 0", alignItems: "center", children: T }),
      /* @__PURE__ */ s.jsx(ae.Paragraph, { color: "secondary", children: "This integration is not properly configured and could not be loaded. Please contact your administrator." })
    ] });
  if (!u)
    return /* @__PURE__ */ s.jsx(W, { margin: "200 0", flexDirection: "column", children: /* @__PURE__ */ s.jsx(
      Xe.Item,
      {
        contentLeft: T,
        title: "Something went wrong. Please try again later.",
        variant: "dense"
      }
    ) });
  const g = r?.graphQLErrors || [];
  return /* @__PURE__ */ s.jsxs(
    W,
    {
      margin: "200 0 300",
      flexDirection: "column",
      className: Pe.errorWrapper,
      children: [
        g.map((x, p) => {
          const E = x?.extensions?.integration, S = E?.message || r?.message || "No error message available", R = E?.responseBody && JSON.parse(E?.responseBody), I = R?.errorMessages || [], A = R?.warningMessages || [], N = [...I, ...A].join(" ");
          return /* @__PURE__ */ s.jsx(
            Xe.Item,
            {
              title: S,
              titleSecondary: N,
              contentLeft: T
            },
            p
          );
        }),
        /* @__PURE__ */ s.jsxs(W, { margin: "200 0 300", flexDirection: "column", gap: "200", children: [
          /* @__PURE__ */ s.jsx(
            qr,
            {
              variant: "info",
              description: /* @__PURE__ */ s.jsx(ae.Paragraph, { variant: "4", children: "Please copy the error details by clicking on the button below and include them in your support request." })
            }
          ),
          /* @__PURE__ */ s.jsxs(W, { flexDirection: "row", gap: "200", justifyContent: "space-between", children: [
            t && /* @__PURE__ */ s.jsx(ke, { variant: "secondary", icon: "sync", onClick: () => t(), children: "Retry" }),
            /* @__PURE__ */ s.jsx(
              ke,
              {
                variant: "secondary",
                icon: m ? "done" : "copy",
                onClick: () => y(JSON.stringify(g, null, 2)),
                className: Pe.copyIcon,
                children: "Copy error payload"
              }
            )
          ] })
        ] })
      ]
    }
  );
};
function ln(r, t = !0) {
  try {
    return JSON.parse(JSON.stringify(r));
  } catch {
    return t && console.error(`Could not make a copy of ${JSON.stringify(r)}`), {};
  }
}
const un = (r) => `${r.charAt(0).toUpperCase()}${r.slice(1).toLowerCase()}`, St = "DD MMM YYYY @ HH:mm";
function fn(r) {
  try {
    return new Intl.DisplayNames(["en"], { type: "region" }).of(
      r.toUpperCase()
    ) ?? r;
  } catch {
    return r;
  }
}
const dn = [
  "AF",
  "AX",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AI",
  "AG",
  "AR",
  "AM",
  "AW",
  "AC",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BM",
  "BT",
  "BO",
  "BA",
  "BW",
  "BV",
  "BR",
  "IO",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CA",
  "CV",
  "BQ",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CX",
  "CC",
  "CO",
  "KM",
  "CG",
  "CD",
  "CK",
  "CR",
  "HR",
  "CU",
  "CW",
  "CY",
  "CZ",
  "CI",
  "DK",
  "DJ",
  "DM",
  "DO",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "SZ",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "PF",
  "TF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GL",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GW",
  "GY",
  "HT",
  "HM",
  "VA",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "KP",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MO",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MQ",
  "MR",
  "MU",
  "YT",
  "MX",
  "MD",
  "MC",
  "MN",
  "ME",
  "MS",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "AN",
  "NC",
  "NZ",
  "NI",
  "NE",
  "NG",
  "NU",
  "NF",
  "MK",
  "NO",
  "OM",
  "PK",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PN",
  "PL",
  "PT",
  "QA",
  "CM",
  "RE",
  "RO",
  "RU",
  "RW",
  "BL",
  "SH",
  "KN",
  "LC",
  "MF",
  "PM",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SX",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "VC",
  "SD",
  "SR",
  "SJ",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TL",
  "TG",
  "TK",
  "TO",
  "TT",
  "TA",
  "TN",
  "TR",
  "TM",
  "TC",
  "TV",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UM",
  "UY",
  "UZ",
  "VU",
  "VE",
  "VN",
  "VG",
  "WF",
  "EH",
  "YE",
  "ZM",
  "ZW",
  "ZZ"
], pn = (r) => {
  if (!r?.trim())
    return "Please add a valid subdomain";
  const a = ["https://", "http://"].find(
    (m) => r.startsWith(m)
  ), i = a ? `Please remove the protocol \`${a}\` from the hostname` : "", u = r.endsWith("/") ? "Please remove the trailing `/` from the hostname" : "";
  if (i && u)
    return `Please remove the protocol \`${a}\` and the trailing \`/\` from the hostname`;
  if (i)
    return i;
  if (u)
    return u;
};
function At(r) {
  const t = r.split(".")[1];
  if (!t)
    throw Error("Invalid token");
  const a = t.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(atob(a).toString());
  } catch (i) {
    throw Error(
      `Failed to parse the JSON Web Token with the following error: ${i}`
    );
  }
}
function wt(r) {
  const { user_id: t, iss: a } = At(r);
  return {
    "x-integration-user-id": t,
    "x-integration-organization-id": a
  };
}
function Nt(r) {
  return r.startsWith("http://localhost");
}
const Dt = lr(null);
function It() {
  const r = ur(Dt);
  if (r === null)
    throw Error(
      "useInboundOAuthContext requires InboundOAuthContext to be used higher up in the component tree, below InboundOAuthContext.Provider"
    );
  return r;
}
function hn() {
  return {
    isInboundOAuth: !1,
    setIsInboundOAuth: () => {
    },
    hasTriggeredAuthorization: !1,
    setHasTriggeredAuthorization: () => {
    }
  };
}
function Pt() {
  return { track: (t, a) => window._partner.events.emit(t, a) };
}
const jt = (r) => {
  switch (r) {
    case "CONNECTED":
      return {
        icon: "check-circle-filled",
        color: G.green[500],
        tooltip: "Connected"
      };
    case "CONNECTING":
      return {
        icon: "sync",
        color: G.neutral[500],
        tooltip: "Connecting.."
      };
    case "CONNECTION_FAILED":
      return {
        icon: "close-circle-filled",
        color: G.red[500],
        tooltip: "Connection failed"
      };
    case "CONNECTION_TIMEOUT":
      return {
        icon: "exclamation-triangle-filled",
        color: G.red[200],
        tooltip: "Connection timeout"
      };
    case "NOT_CONNECTED":
    default:
      return {
        icon: "exclamation-circle-filled",
        color: G.neutral[500],
        tooltip: "Not connected"
      };
  }
}, gn = ({
  configuration: r,
  integrationId: t,
  integrationType: a,
  label: i
}) => {
  const [u, m] = P("CONNECTING"), { track: y } = Pt(), { icon: T, color: g, tooltip: x } = jt(u), p = 3, E = 15, S = 2e3, [R, I] = P({}), [A, N] = P(0), [d, b] = P(S), [$, Z] = P(!1), [Ee, ye] = P(p), {
    isInboundOAuth: be,
    setIsInboundOAuth: Ce,
    hasTriggeredAuthorization: ie,
    setHasTriggeredAuthorization: Re
  } = It(), { baseUrl: K } = r, se = `${K}/auth/connect/${a.toLowerCase()}/${t}`, M = `${K}/auth/status/${a.toLowerCase()}/${t}`, F = u === "CONNECTING", U = (O) => Object.keys(O).length === 0, H = () => {
    Z(!1), N(0);
  };
  k(() => {
    const O = localStorage.getItem("authData");
    if (O) {
      const B = JSON.parse(O ?? "{}").access_token;
      I({
        method: "GET",
        headers: {
          "content-type": "application/json",
          authorization: `Bearer ${B}`,
          ...Nt(K) && wt(B)
        }
      });
    }
  }, [K]), k(() => {
    U(R) || Z(!0);
  }, [R]);
  const ce = () => {
    ye(E), fetch(M, { ...R }).then((O) => O.json()).then(({ data: O }) => {
      const { status: L } = O;
      L === "CONNECTING" && m("CONNECTING"), L === "CONNECTED" && (y("settings:view:oauth:succeeded", {
        widgetId: t,
        widgetType: a
      }), m("CONNECTED"), H()), L === "NOT_CONNECTED" && (m("NOT_CONNECTED"), H());
    }).catch((O) => {
      console.warn(
        `Fetching OAuth status failed for ${a} ${t}`,
        O
      ), m("CONNECTION_FAILED");
    });
  };
  tt(
    () => {
      A >= Ee ? (m("CONNECTION_TIMEOUT"), H()) : (ce(), N(A + 1));
    },
    $ ? d : null
  );
  const X = () => {
    y("settings:view:oauth:started", {
      widgetId: t,
      widgetType: a
    }), fetch(se, { ...R }).then((O) => O.json()).then(({ data: O }) => {
      const { url: L } = O, B = 620, ee = 800, le = window.innerWidth / 2 - B / 2, _e = window.innerHeight / 2 - ee / 2;
      m("CONNECTING"), Z(!0), window.open(
        L,
        "DixaPartnerOAuth",
        `toolbar=no,
						location=no,
						status=no,
						menubar=no,
						scrollbars=yes,
						resizable=yes,
						width=${B},
						height=${ee},
						left=${le},
						top=${_e}`
      );
    }).catch((O) => {
      console.warn(
        `Fetching OAuth connection failed for ${a} ${t}`,
        O
      ), m("CONNECTION_FAILED");
    });
  };
  return k(() => {
    be && !ie && !U(R) && (Re(!0), Ce(!1), X());
  }, [R]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(oe, { span: 3, children: /* @__PURE__ */ s.jsx(
      Q,
      {
        label: i,
        meta: {
          warning: "All agents interact with the widget using your access permissions."
        },
        style: { marginBottom: 20 },
        children: /* @__PURE__ */ s.jsxs(W, { flexDirection: "row", alignItems: "baseline", gap: "300", children: [
          /* @__PURE__ */ s.jsx(
            ke,
            {
              icon: "key",
              variant: "secondary",
              onClick: X,
              disabled: F,
              style: { marginBottom: 8 },
              children: "Start authorization"
            }
          ),
          /* @__PURE__ */ s.jsx(Qr, { content: x, children: F ? /* @__PURE__ */ s.jsx(fr, { "data-testid": "oauth-button-spinner", size: 18 }) : /* @__PURE__ */ s.jsx(
            Fe,
            {
              "data-testid": "oauth-button-status-icon",
              name: T,
              color: g
            }
          ) })
        ] })
      }
    ) }),
    /* @__PURE__ */ s.jsx(oe, { span: 3 })
  ] });
}, mr = lr(null), vn = (
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  mr.Provider
);
function Er() {
  const r = ur(mr);
  if (r === null)
    throw Error(
      "useWidgetContext requires WidgetContext to be used higher up in the component tree, below WidgetContextProvider"
    );
  return r;
}
const kt = "_settingsWrapper_eleyu_1", Mt = {
  settingsWrapper: kt
}, Ft = Me`
  query getLists {
    Klaviyo {
      get_lists {
        ... on Klaviyo_get_lists_response {
          ... on Klaviyo_GetListListResponseCollectionCompoundDocument {
            data {
              type
              id
              attributes {
                name
                created
                updated
              }
              links {
                self
              }
            }
            links {
              self
            }
          }
          ... on Klaviyo_ClientError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
          ... on Klaviyo_ServerError_response {
            errors {
              id
              code
              title
              detail
              source {
                pointer
                parameter
              }
            }
          }
        }
      }
    }
  }
`, sr = [], mn = ({
  settings: r,
  getValueByKey: t,
  handleChangeSelect: a
}) => {
  const i = "subscriptionListId", m = r?.find(
    (d) => d.key === i
  )?.label ?? "Activate re-/subscription list selection", y = t(i)?.value, { useQuery: T } = Er(), [g, x] = P(sr), [p, E] = P(!!y), [S, R] = P(y), {
    data: I,
    error: A,
    loading: N
  } = T(Ft, {
    skip: !p,
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: !0
  });
  return k(() => {
    y && (R(y), E(!0));
  }, [y]), k(() => {
    const d = I?.Klaviyo?.get_lists;
    if (p && d && !N && !A) {
      const b = d?.data?.map(
        ($) => ({
          value: $?.id,
          label: $?.attributes?.name
        })
      ) || sr;
      x(b);
    }
  }, [p, I, N, A]), /* @__PURE__ */ s.jsxs(s.Fragment, { children: [
    /* @__PURE__ */ s.jsx(oe, { span: 3, children: /* @__PURE__ */ s.jsxs(
      W,
      {
        gap: "300",
        flexDirection: "column",
        className: Mt.settingsWrapper,
        children: [
          /* @__PURE__ */ s.jsx(Q, { label: m, children: /* @__PURE__ */ s.jsx(
            Zr,
            {
              input: {
                name: `${i}-switch`,
                value: "switchValueFromComponent",
                checked: p,
                onChange: () => {
                  const d = !p;
                  d || a(i, {
                    selectedValues: [
                      {
                        label: "",
                        value: ""
                      }
                    ]
                  }), E(d);
                }
              }
            }
          ) }),
          p && A && !N && /* @__PURE__ */ s.jsx(Q, { children: /* @__PURE__ */ s.jsx(xt, { error: A }) }),
          p && !A && N && /* @__PURE__ */ s.jsx(Q, { children: /* @__PURE__ */ s.jsx(W, { justifyContent: "center", margin: "0 0 300 0", children: /* @__PURE__ */ s.jsx(fr, {}) }) }),
          p && !A && !N && g && /* @__PURE__ */ s.jsx(Q, { label: "Available lists to subscribe to", children: /* @__PURE__ */ s.jsx(
            Xr,
            {
              required: !0,
              placeholder: "Select a list",
              onChange: (d) => {
                a(i, d), R(d?.selectedValues?.[0].value);
              },
              getItemTitleByValue: (d) => d ? /* @__PURE__ */ s.jsx(ae.Paragraph, { children: d.label }) : null,
              value: S ? [
                {
                  label: (g || []).find(
                    (d) => d.value === S
                  )?.label,
                  value: S
                }
              ] : [],
              equalityFn: (d, b) => d.value === b.value,
              children: g.map((d) => /* @__PURE__ */ s.jsx(et.Item, { value: d, children: d.label }, d.value))
            }
          ) })
        ]
      }
    ) }),
    /* @__PURE__ */ s.jsx(oe, { span: 3 })
  ] });
}, En = (r) => {
  if (r == null)
    return null;
  if (typeof r == "boolean" || r === "true" || r === "false") {
    const i = r === "true" || r === !0;
    return /* @__PURE__ */ s.jsx(
      Fe,
      {
        name: i ? "check-circle-filled" : "close-circle-filled",
        color: i ? G.green[500] : G.red[500],
        size: 14,
        "data-testid": `displayAttributeValue-icon-${i ? "true" : "false"}`
      }
    );
  }
  if (typeof r == "number" || /^\d*\.?\d+$/.test(r))
    return /* @__PURE__ */ s.jsx(je, { variant: "success", size: "small", children: r });
  if (r.startsWith("days_ago: ")) {
    const i = r.replace("days_ago: ", ""), u = i.startsWith("-"), m = i === "0", y = u ? `${i.replace("-", "")} days ago` : `in ${i} days`;
    return /* @__PURE__ */ s.jsx(ae.Paragraph, { variant: "5", color: "secondary", children: m ? "today" : y });
  }
  const a = nt(r);
  return a.isValid() ? /* @__PURE__ */ s.jsx(ae.Paragraph, { variant: "5", color: "secondary", children: a.format(St) }) : /* @__PURE__ */ s.jsx(je, { variant: "info", size: "small", children: r });
}, Lt = Me`
  query read($conversationId: String!) {
    Storage {
      widgetData(conversation: $conversationId)
    }
  }
`, Wt = Me`
  mutation store($conversationId: String!, $data: Storage_JSONObject) {
    Storage {
      storeWidgetData(conversation: $conversationId, data: $data) {
        data
      }
    }
  }
`;
function yn(r) {
  const { useQuery: t, useMutation: a } = Er(), [i, u] = P(), [m, y] = P(), [T, g] = P(!1), {
    loading: x,
    data: p,
    error: E
  } = t(
    Lt,
    {
      skip: !r,
      variables: {
        conversationId: r?.toString()
      }
    }
  ), [S, { loading: R, error: I }] = a(
    Wt
  ), A = async (N, d) => await S({
    variables: {
      conversationId: (d ?? r)?.toString(),
      data: N
    }
  }).then(
    ({ data: $ }) => u($?.Storage?.storeWidgetData?.data ?? {})
  );
  return k(() => {
    !x && p && u(p?.Storage?.widgetData ?? {});
  }, [p, x]), k(() => E && y(E), [E]), k(() => g(x), [x]), k(() => I && y(I), [I]), k(() => g(R), [R]), {
    data: i,
    loading: T,
    store: A,
    error: m
  };
}
export {
  xt as DisplayErrors,
  Zt as DixaApiTokenSettings,
  Dt as InboundOAuthContext,
  mn as KlaviyoSubscribeSetting,
  gn as OAuthSettings,
  vn as WidgetContextProvider,
  un as capitalizeFirstCharacter,
  dn as countryCodes,
  hn as createMockInboundOAuthContextOptions,
  ln as deepClone,
  St as defaultDateFormat,
  En as displayAttributeValue,
  jt as getConnectionStatusValues,
  fn as getCountryNameFromCountryCode,
  Ft as getListsQuery,
  wt as getPartnerDevApiHeaders,
  Xt as hasDixaHeaderCheckError,
  en as hasDownstreamApiAuthorizationError,
  an as hasDownstreamApiBadRequestError,
  on as hasDownstreamApiConflictError,
  sn as hasDownstreamApiForbiddenError,
  nn as hasDownstreamApiNotFoundError,
  rn as hasDownstreamApiPermissionError,
  tn as hasDownstreamApiServiceUnavailableError,
  cn as hasDownstreamApiTooManyRequestsError,
  Rt as hasWidgetMisconfiguredError,
  dt as isDixaHeaderCheckError,
  pt as isDownstreamApiAuthorizationError,
  Et as isDownstreamApiBadRequestError,
  mt as isDownstreamApiConflictError,
  yt as isDownstreamApiForbiddenError,
  vt as isDownstreamApiNotFoundError,
  ht as isDownstreamApiPermissionError,
  gt as isDownstreamApiServiceUnavailableError,
  bt as isDownstreamApiTooManyRequestsError,
  Nt as isRunningLocalPartnerApi,
  Ct as isWidgetMisconfiguredError,
  qt as makeExecuteQuery,
  zt as makeUseLazyQuery,
  Qt as makeUseMutation,
  Jt as makeUseQuery,
  At as parseAccessToken,
  _t as useCopyWithDelay,
  yn as useData,
  It as useInboundOAuthContext,
  Pt as useTracking,
  Er as useWidgetContext,
  pn as validateApiHostName
};
